import React from "react";

import { SvgIcon, SvgIconProps } from "@origin-digital/ods-icons";

export const IconReduction = (props: SvgIconProps) => {
  return (
    <SvgIcon data-id="icon-reduction" color="inherit" {...props}>
      <path d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z" />
    </SvgIcon>
  );
};
